import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { catchError, Observable, of } from 'rxjs';
import { AgencyActivationService } from './data-access-agency-activation/agency-activation.service';
import { AgencyActivationDetails } from './domain/model/agency-activation.model';

export const agencyActivationResolver = (
  route: ActivatedRouteSnapshot,
  _state: RouterStateSnapshot,
): Observable<AgencyActivationDetails | null> => {
  const agencyActivationService = inject(AgencyActivationService);
  const activationCode = route.params['activationCode'];

  return agencyActivationService.getActivationDetails(activationCode).pipe(
    catchError((e) => {
      console.error(e);
      return of(null);
    }),
  );
};
